import { useTranslation } from "react-i18next"
import { useTheme } from "@mui/material/styles"

import type { ContextDevice } from "types/device.types"

import DeviceStatusMarks from "./DeviceStatusMarks"
import EntityLink from "./EntityLink"
import OverflowChip, { OverflowItem } from "./OverflowChip"

interface DeviceOverflowChipProps {
  /** Every device on the asset, already sorted by severity. The list shows the hidden ones. */
  devices: ContextDevice[]
  /** How many of them are shown next to the chip. */
  visibleCount: number
}

const DeviceOverflowChip = ({ devices, visibleCount }: DeviceOverflowChipProps) => {
  const { t } = useTranslation()
  const theme = useTheme()

  const hidden = devices.slice(visibleCount)
  // A hidden problem gets a dot so it is not missed behind the count.
  const dotColor = hidden.some((device) => device.hasAlert)
    ? theme.palette.error.main
    : hidden.some((device) => device.status === "inactive")
      ? theme.palette.deviceStatus.inactive.main
      : undefined

  return (
    <OverflowChip
      count={hidden.length}
      ariaLabel={t("asset_context.MORE_DEVICES", { count: hidden.length })}
      dotColor={dotColor}
    >
      {hidden.map((device) => (
        <OverflowItem key={device.id}>
          <EntityLink entity="device" id={device.id} name={device.name} />
          <DeviceStatusMarks status={device.status} hasAlert={device.hasAlert} />
        </OverflowItem>
      ))}
    </OverflowChip>
  )
}

export default DeviceOverflowChip
